import { Center, Spinner, Button, Text, VStack } from "@chakra-ui/react";
import { useContainer } from "./useContainer";
import { EntryItem } from "./entryItem";
import { LegalAgreementModal } from "@/components/contest/legalAgreementModal/legalAgreementModal";
import { Metadata } from "@/components/common/metadata";
import { AppHeader } from "@/components/common/header/appHeader";

const FIXED_FOOTER_HEIGHT = {
  base: "64px",
  lg: "100px",
};

export const ContestEntryContainer = () => {
  const {
    contestDetail,
    items,
    isLoading,
    showEmptyData,
    infiniteRef,
    hasNext,
    submitEnabled,
    submitButtonColor,
    submitButtonText,
    legalAgreementDisclosure,
    handleSubmit,
    handleOnSubmitForLegalAgreement,
  } = useContainer();
  return (
    <>
      <Metadata title="応募作品の選択" />
      <VStack
        minH="100svh"
        w="100%"
        h="100%"
        bg="backgroundPrimary"
        alignItems="center"
        pb="env(safe-area-inset-bottom)"
      >
        <AppHeader
          title="応募作品の選択"
          backAction={() => {
            window.history.back();
          }}
          moreButton={false}
        />
        <VStack
          w="100%"
          h="100%"
          maxW="breakpoint-md"
          overflowY="scroll"
          scrollbarWidth="none"
          gap="0"
          pb={{
            base: FIXED_FOOTER_HEIGHT.base,
            lg: FIXED_FOOTER_HEIGHT.lg,
          }}
        >
          {items.length > 0 ? (
            <VStack w="full">
              <Text
                w="100%"
                p={4}
                color="contentPrimary"
                fontSize={{
                  base: 14,
                  lg: 16,
                }}
              >
                応募する作品を選択してください。募集期間中であれば、いつでも変更可能です。
              </Text>

              {/* Items */}
              <VStack w="100%" gap={0}>
                {items.map((item) => (
                  <EntryItem key={`entry-item-${item.id}`} item={item} />
                ))}
              </VStack>
            </VStack>
          ) : showEmptyData ? (
            <Center w="100%" h="100%">
              <Text color="contentSecondary" fontSize="md">
                応募可能な作品がありません。
              </Text>
            </Center>
          ) : null}

          {isLoading || hasNext ? (
            <Spinner size="lg" ref={infiniteRef} />
          ) : null}
        </VStack>

        <Center
          px="6"
          py={{
            base: 2,
            lg: 6,
          }}
          w="100%"
          h={{
            base: FIXED_FOOTER_HEIGHT.base,
            lg: FIXED_FOOTER_HEIGHT.lg,
          }}
          position="fixed"
          bottom={0}
          bg="backgroundPrimary"
          borderTopWidth={0.5}
          borderTopColor="borderBorderPrimary"
        >
          <Button
            bg={submitButtonColor}
            color="#EDEDED"
            fontSize={{
              base: 16,
              lg: 18,
            }}
            fontWeight="bold"
            borderRadius="full"
            lineHeight={1}
            px="18px"
            w="100%"
            maxW="480px"
            h={{
              base: "48px",
              lg: "52px",
            }}
            _disabled={{
              bg: "backgroundDisable",
            }}
            disabled={!submitEnabled}
            onClick={handleSubmit}
          >
            {submitButtonText}
          </Button>
        </Center>
      </VStack>
      {contestDetail?.legalAgreement ? (
        <LegalAgreementModal
          isOpen={legalAgreementDisclosure.open}
          onClose={legalAgreementDisclosure.onClose}
          onPressSubmit={handleOnSubmitForLegalAgreement}
          legalAgreement={contestDetail.legalAgreement}
        />
      ) : null}
    </>
  );
};
